import React from "react";
import { Grid, Col } from "@vds/grids";
import { Line } from "@vds/lines";
import { Text } from '@vds/core';
import { MarginSpacerL } from "common/components/styleTag";
import { RowNoPad } from "./styles";
import styled from "styled-components";

const DeviceTileSection = ({ title, children,bold=true, ...props }) => {
  return (
    <Container>
    <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} colGutter={false}>
      <RowNoPad>
        <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          <MarginSpacerL />
          <Line type="secondary" />
          <MarginSpacerL />
          <Text kind="body" bold={bold} size="large">
            {title}
          </Text>
        </Col>
      </RowNoPad>
      <RowNoPad>
        <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          <MarginSpacerL />
          {children}
        </Col>
      </RowNoPad>
    </Grid>
    </Container>
  );
};
const Container =styled.div`
pointer-events: auto !important;
`

export default DeviceTileSection;
